import { AchievementsDialog } from '../dialogs/Achievements';
import { BonusDialog } from '../dialogs/Bonus';
import { CourtingDialog } from '../dialogs/Courting';
import { LeagueDialog } from '../dialogs/League';
import { ProfileDialog, ReportDialog } from '../dialogs/Profile';
import { RatingsDialog } from '../dialogs/Ratings';
import { HoroscopeDialog } from '../dialogs/Horoscope';
import { FriendsDialog, SettingsDialog } from '../dialogs/Settings';
import { ReferralDialog, SendDialog, ShopDialog, VipDialog } from '../dialogs/Shop';
import { StylingDialog } from '../dialogs/Styling';
import { WheelOverlay } from '../dialogs/Wheel';
import { useUi } from '../store/ui';

/** The dialog open over the table, if any. */
export function GameDialogs() {
  const dialog = useUi((s) => s.dialog);
  if (!dialog) return null;
  const userId = String(dialog.props?.userId ?? '');
  switch (dialog.kind) {
    case 'shop':
      return <ShopDialog />;
    case 'vip':
      return <VipDialog />;
    case 'referral':
      return <ReferralDialog />;
    case 'send':
      return <SendDialog currency={dialog.props?.currency === 'GM' ? 'GM' : 'HEARTS'} />;
    case 'wheel':
    case 'chances':
      return <WheelOverlay />;
    case 'league':
      return <LeagueDialog />;
    case 'boosters':
      return <LeagueDialog boostersOpen />;
    case 'achievements':
      return <AchievementsDialog />;
    case 'horoscope':
      return <HoroscopeDialog />;
    case 'ratings':
      return <RatingsDialog />;
    case 'styling':
      return <StylingDialog />;
    case 'settings':
      return <SettingsDialog />;
    case 'friends':
      return <FriendsDialog />;
    case 'profile':
      return <ProfileDialog key={userId} userId={userId} />;
    case 'report':
      return <ReportDialog userId={userId} />;
    case 'bonus':
      return <BonusDialog />;
    case 'courting':
      return (
        <CourtingDialog
          userId={userId}
          name={String(dialog.props?.name ?? '')}
          price={Number(dialog.props?.price ?? 0)}
        />
      );
    default:
      return null;
  }
}
